// ChartWrapper.tsx
import React from 'react';
import { NONE, PREVIOS_PERIOD } from '../AnalyticsConstants';
import SynchronizedCharts from './SynchronizedCharts';
import DashedLineChart from '../Components/DashedLineChart';
import ColumnChart from '../Components/ColumnChart';
import ColumnAndLineChart from '../Components/ColumnAndLineChart';

type ChartWrapperProps = {
    chartType: string;
    compareType: string;
    data: any;
    combinedData?: any;
    dashedArray?: number[];
    metricName?: string;
    xAxis?: string[];
    granularity?: string;
    timezone: string;
};

const ChartWrapper = React.memo(({ chartType, compareType, data, combinedData, dashedArray, metricName, xAxis, granularity, timezone}: ChartWrapperProps) => {

    if (compareType === PREVIOS_PERIOD && chartType === "Line Chart") {
        return (
        <SynchronizedCharts 
            data={data} 
            metricName={metricName} 
            xAxis={xAxis} 
            granularity={granularity} 
            timezone={timezone} 
        />
        );
    }

    if (compareType === NONE) {
        switch (chartType) {
        case "Line Chart":
            return (
                <DashedLineChart 
                    data={data} 
                    dashedArray={dashedArray} 
                    metricName={metricName} 
                    xAxis={xAxis} 
                    granularity={granularity} 
                    timezone={timezone} 
                />
            );
        case "Column Chart":
            return (
                <ColumnChart 
                    data={data} 
                    metricName={metricName} 
                    xAxis={xAxis} 
                    granularity={granularity} 
                    timezone={timezone} 
                />
            );
        case "Line & Column":
            return (
                <ColumnAndLineChart 
                    data={combinedData} 
                    xAxis={xAxis} 
                    granularity={granularity} 
                    timezone={timezone} 
                />
            );
        default:
            return null;
        }
    }

    return null;
});

ChartWrapper.displayName = 'ChartWrapper';

export default ChartWrapper;